import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { IMAGES } from '../data/content';
const results = ['Abrir la vianda y encontrarla vacía', 'Saber qué cocinar sin pensarlo cada mañana', 'Un hijo que disfruta comidas caseras y nutritivas', 'Tu rutina más simple y tu cabeza más liviana'];
export function Transformation() {
  return <section className="w-full overflow-hidden bg-cream py-16 sm:py-24" data-id="element-200" data-mp="wktyna8ski6g">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-5 lg:grid-cols-2 lg:gap-14" data-id="element-201" data-mp="wihhgzauybug">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="relative order-2 lg:order-1" data-id="element-202" data-mp="16a3un16rakzu">
          <div className="absolute -bottom-4 -left-4 h-full w-full rounded-3xl bg-green-soft" data-id="element-203" data-mp="1fcmtla7f8dgt" />
          <img src={IMAGES.transformation} alt="Mamá relajada preparando una vianda saludable en su cocina" className="relative w-full rounded-3xl object-cover shadow-xl" data-id="element-204" data-mp="1kaema6fw43m2" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="order-1 lg:order-2" data-id="element-205" data-mp="135299u5z1she">
          <span className="inline-block rounded-full bg-green-soft px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide text-green-deep" data-id="element-206" data-mp="1uw01yy8c9d2v">
            Imaginate esto
          </span>
          <h2 className="mt-4 font-display text-3xl font-black leading-tight text-green-deep sm:text-4xl" data-id="element-207" data-mp="1m2wqgvh97aav">
            Que las viandas dejen de ser una preocupación diaria
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-[#4A5748]" data-id="element-208" data-mp="2elk6vxlb215m">
            Imaginate no volver a preguntarte qué cocinar, tener siempre una idea
            lista y sentir la tranquilidad de saber que tu hijo va a disfrutar su
            vianda.
          </p>

          <ul className="mt-7 space-y-3.5" data-id="element-209" data-mp="2xoueo4167kgn">
            {results.map(r => <li key={r} className="flex items-start gap-3" data-id="element-210" data-mp="2xqyh0hjf8bet">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-green-brand" data-id="element-211" data-mp="2jwxq29ypnsp0">
                  <CheckIcon className="h-4 w-4 text-white" data-id="element-212" data-mp="2nxhjb2g5yc5v" />
                </span>
                <span className="text-[15px] font-semibold text-[#3A463A]" data-id="element-213" data-mp="29xyfumyarozw">{r}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}